// extracted by mini-css-extract-plugin
export default {"container":"badge_container__neqf9","badge":"badge_badge__X0jCN","pulse":"badge_pulse__WYxIi"};